import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { SelectAreaPage } from './select-area.page';

const routes: Routes = [
  {
    path: '',
    component: SelectAreaPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class SelectAreaPageRoutingModule {}
